import * as Yup from "yup";

export function validateEmail(value) {
  let error;
  if (!value) {
    error = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Invalid email address';
  }
  return error;
}
export function validateIsRequired(value) {
  if (typeof value === 'string') {
    return value.trim() === ''
  }
  if (typeof value === 'number') {
    return isNaN(value)
  }
  return false
}
export function validateCurrency(value) {
  return value < 0 || !/^\d{1,3}(\.\d{3})*,\d{2}$/.test(value);
}
export function validatePercentage(value, max = 100) {
  if (value) {
    value = parseFloat(value.toString().replace(",", ".").trim())
    return (value < 0 || value > max) || !/^[+-]?\d+(\.\d+)?$/.test(value);
  }
}
export function validateInteger(value, min = 0, max = 1000000) {
  value = parseInt(value)
  return value < min || value > max || !Number.isInteger(value);
}
export function transformCurrencyYup(value, originalValue) {
  if (typeof originalValue === "string") {
    const cleaned = originalValue
      .replace(/[R$\s.]/g, "")
      .replace(",", ".")
    return cleaned === "" ? null : Number(cleaned)
  }
  return value
}
export function transformPercentageYup(value, originalValue) {
  if (typeof originalValue === "string") {
    const cleaned = originalValue
      .replace(/[%\s.]/g, "")
      .replace(",", ".")

    return cleaned === "" ? null : Number(cleaned)
  }
  return value
}
export function currencyField(label = "Produtos") {
  return Yup.number()
    .transform(transformCurrencyYup)
    .typeError(`${label} deve ser moeda`)
    .min(0, `${label} deve ser no mínimo R$ 0,00`)
    .max(1_111_111_111_111.11, `${label} máximo é R$ 1.111.111.111.111,11`)
    .nullable()
}
export function percentageField(label = "Taxas") {
  return Yup.number()
    .transform(transformPercentageYup)
    .typeError(`${label} deve ser porcentagem`)
    .min(0, "Valor mínimo: % 0,00")
    .max(100, "Valor máximo: % 100,00")
    .nullable()
}
